import { COOKIE_CONSENT_NAME } from "./constants";
import { getCookieConsentValue } from "react-cookie-consent";

/**
 * This is where we have global functions. We want to keep this file as small as possible
 */

export function isCookiesAccepted({ isInIframe } = {}) {
    return isInIframe ? true : getCookieConsentValue(COOKIE_CONSENT_NAME) === "true";
}
